<app-portal-modal-shell
  [title]="title"
  [subtitle]="message"
  [size]="size"
  [busy]="busy"
  [dismissible]="!busy"
  [showOverlay]="false"
  (dismiss)="dismiss()">
  <div class="portal-prompt-dialog__fields">
    <div class="form-check form-switch portal-prompt-select__toggle" *ngIf="toggleLabel">
      <input
        class="form-check-input"
        type="checkbox"
        role="switch"
        id="portal-prompt-select-extra"
        [ngModel]="showExtra"
        (ngModelChange)="onToggle($event)"
        [disabled]="busy" />
      <label class="form-check-label" for="portal-prompt-select-extra">{{ toggleLabel }}</label>
    </div>

    <label class="form-label" *ngIf="inputLabel">{{ inputLabel }}</label>

    <ng-container *ngIf="searchable; else nativeSelect">
      <div class="portal-prompt-select__search">
        <i class="ki-solid ki-magnifier" aria-hidden="true"></i>
        <input
          type="search"
          class="form-control"
          [placeholder]="searchPlaceholder"
          [ngModel]="query"
          (ngModelChange)="onQueryChange($event)"
          [disabled]="busy"
          autocomplete="off" />
        <span *ngIf="searching" class="spinner-border spinner-border-sm portal-prompt-select__spinner"></span>
      </div>
      <div class="portal-prompt-select__list" role="listbox">
        <button
          type="button"
          class="portal-prompt-select__option"
          *ngFor="let opt of filteredOptions"
          [class.portal-prompt-select__option--active]="opt.value === value"
          [disabled]="busy"
          role="option"
          [attr.aria-selected]="opt.value === value"
          (click)="pickOption(opt.value)">
          {{ opt.label }}
        </button>
        <div class="portal-prompt-select__empty text-muted" *ngIf="!filteredOptions.length">
          {{ 'COMMON.NO_RESULTS' | translate }}
        </div>
      </div>
    </ng-container>

    <ng-template #nativeSelect>
      <select
        class="form-select"
        [ngModel]="value"
        (ngModelChange)="onValueChange($event)"
        [disabled]="busy">
        <option *ngFor="let opt of filteredOptions" [value]="opt.value">{{ opt.label }}</option>
      </select>
    </ng-template>

    <div class="text-danger fs-8 mt-2" *ngIf="error">{{ error }}</div>
  </div>
  <div portalModalFooter class="d-flex justify-content-end flex-wrap gap-2 w-100">
    <app-portal-button
      layout="label"
      variant="light"
      [disabled]="busy"
      (pressed)="dismiss()">
      {{ cancelLabel || ('COMMON.CANCEL' | translate) }}
    </app-portal-button>
    <app-portal-button
      layout="label"
      [variant]="confirmVariant"
      [disabled]="busy"
      (pressed)="submit()">
      {{ confirmLabel || ('COMMON.CONFIRM' | translate) }}
    </app-portal-button>
  </div>
</app-portal-modal-shell>
